import type { ComponentProps } from 'react';

import ArrowLeftButton from '@/public/assets/svg/Icon/ArrowLeftButton.svg';

export const IconArrowLeftButton = ({ ...props }: ComponentProps<'svg'>) => {
  return <ArrowLeftButton {...props} />;
};
